// What a refused or failed checkout request means for the buyer, in words.

export function refusalMessage(error, fallback) {
    const data = error?.response?.data
    if (data?.code === 'INVALID_PLAN')
        return 'That plan is not available. Pick another one.'
    if (data?.code === 'COUNTRY_REQUIRED') return 'Please choose your country.'
    if (data?.code === 'COUPON_INVALID')
        return 'That coupon code is not valid. Check it or leave the field empty.'
    if (data?.code === 'VAT_INVALID')
        return "That VAT number isn't valid. Check it, or leave the field empty."
    if (data?.code === 'ALREADY_SUBSCRIBED')
        return 'You already have a subscription, so nothing was charged. Change your plan from your subscription page.'
    if (data?.code === 'INTENT_NOT_AUTHORIZED')
        return 'The card was not authorised. Please try again.'
    if (data?.code === 'PAYMENT_DECLINED')
        return 'Your card was declined, so nothing was charged. Try another card.'
    if (data?.code === 'BILLING_UPSTREAM')
        return 'The payment provider did not answer. Nothing was charged — please try again.'
    if (data?.code === 'BILLING_INTERNAL')
        return 'Something went wrong on our side. Your card was not charged. Please try again.'
    if (data?.code === 'BILLING_MISCONFIGURED')
        return 'Payments are not set up correctly at the moment. Nothing was charged, and retrying will not help — please contact support.'
    if (typeof data?.message === 'string' && data.message) return data.message
    return fallback
}

// Whether the charge may have happened: no answer at all, or a server failure
// other than a configuration refusal. axios 0.27 hands the raw XHR over as
// `response` on a network failure, so "no answer" is a missing status.
export function paymentOutcomeUnknown(error) {
    const status = error?.response?.status || 0
    return (
        status === 0 ||
        (status >= 500 && error.response.data?.code !== 'BILLING_MISCONFIGURED')
    )
}

// Switching again onto the plan already set charges nothing, so "try again"
// is safe whenever the outcome is unknown.
export function changeFailureMessage(error) {
    const code = error?.response?.data?.code
    if (code === 'PLAN_NOT_SAVED')
        return 'Your plan change went through, but we could not save it yet. Press the button again to finish. You will not be charged twice.'
    if (paymentOutcomeUnknown(error))
        return 'We could not confirm the plan change. Press the button again to check. You will not be charged twice.'
    return refusalMessage(
        error,
        'The plan change did not go through. Nothing was charged.'
    )
}

export function failureCode(failure) {
    return String(
        failure?.response?.data?.code || failure?.code || failure?.type || 'UNKNOWN'
    )
}

// The readable side of failureCode: Chargebee's raw codes (e.g. 3004) mean
// nothing on a dashboard without it.
export function failureMessage(failure) {
    return String(
        failure?.response?.data?.message || failure?.message || ''
    ).slice(0, 160)
}
